import canUseDOM from './canUseDOM';

// Scroll to the Product Description and Review Tabs
export function scrollToId(elementId: string, selectedClass: string) {
  if (canUseDOM()) {
    const element = document.getElementById(elementId);

    if (element) {
      element.click();
      element.classList.add(selectedClass);
      element.scrollIntoView({
        block: 'center',
        behavior: 'smooth'
      });
    }
  }
}

// Scroll to the Description tabbed content from still having the Reviews Tab selected
// Once Description tab is selected, scroll to ReasonsToLove, Learning Outcomes, TopTips depending on which one is clicked
export function scrollToNestedId(
  elementId: string,
  selectedClass: string,
  nestedElementId: string
) {
  if (canUseDOM()) {
    const element = document.getElementById(elementId);
    const nestedElement = document.getElementById(nestedElementId);

    if (element) {
      element.click();
      element.classList.add(selectedClass);
    }

    if (nestedElement) {
      nestedElement.scrollIntoView({
        block: 'center',
        behavior: 'smooth'
      });
    }
  }
}
